import { animate, AnimationEvent, keyframes, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output, TrackByFunction } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { BehaviorSubject } from 'rxjs';
import { SearchParam } from '../../search-param.model';
import { adjustFilters, labelTranslationKeyToString } from '../../helpers';
import { FILTER_PER_ROW } from '../settings';

@Component({
    selector: 'se-ap-search-filters-config-visibility',
    templateUrl: './ap-search-filters-config-visibility.component.html',
    styleUrls: ['./ap-search-filters-config-visibility.component.scss'],
    animations: [
        trigger('movingDownAnimation', [
            transition('* => true', [
                animate(
                    '0.2s',
                    keyframes([
                    style({ transform: 'translateY(-5%)', offset: 0.1 }),
                    style({ transform: 'translateY(100%)', offset: 1 }),
                    ]),
                ),
            ]),
        ]),
        trigger('movedDownAnimation', [
            transition('* => true', [
                animate(
                    '0.2s',
                    keyframes([
                    style({ transform: 'translateY(-45px)', offset: 0 }),
                    style({ transform: 'translateY(0px)', offset: 0.25 }),
                    style({ transform: 'translateY(-24px)', offset: 0.4 }),
                    style({ transform: 'translateY(0px)', offset: 0.55 }),
                    style({ transform: 'translateY(-12px)', offset: 0.65 }),
                    style({ transform: 'translateY(0px)', offset: 0.75 }),
                    style({ transform: 'translateY(-6px)', offset: 0.82 }),
                    style({ transform: 'translateY(0px)', offset: 0.87 }),
                    style({ transform: 'translateY(-4px)', offset: 0.93 }),
                    style({ transform: 'translateY(0px)', offset: 1 }),
                    ]),
                ),
            ]),
        ]),
        trigger('movingUpAnimation', [
            transition('* => true', [
                animate(
                    '0.2s',
                    keyframes([
                    style({ transform: 'translateY(5%)', offset: 0.1 }),
                    style({ transform: 'translateY(-100%)', offset: 1 }),
                    ]),
                ),
            ]),
        ]),
        trigger('movedUpAnimation', [
            transition('* => true', [
                animate(
                    '0.2s',
                    keyframes([
                    style({ transform: 'translateY(45px)', offset: 0 }),
                    style({ transform: 'translateY(0px)', offset: 0.25 }),
                    style({ transform: 'translateY(24px)', offset: 0.4 }),
                    style({ transform: 'translateY(0px)', offset: 0.55 }),
                    style({ transform: 'translateY(12px)', offset: 0.65 }),
                    style({ transform: 'translateY(0px)', offset: 0.75 }),
                    style({ transform: 'translateY(6px)', offset: 0.82 }),
                    style({ transform: 'translateY(0px)', offset: 0.87 }),
                    style({ transform: 'translateY(4px)', offset: 0.93 }),
                    style({ transform: 'translateY(0px)', offset: 1 }),
                    ]),
                ),
            ]),
        ]),
        trigger('leavingLeftAnimation', [
            transition('* => true', [
                animate(
                    '0.2s',
                    keyframes([
                    style({ transform: 'translateX(5%)', offset: 0.1 }),
                    style({ transform: 'translateX(-100%)', offset: 1 }),
                    ]),
                ),
            ]),
        ]),
        trigger('enteringLeftAnimation', [
            transition('* => true', [
                animate(
                    '0.2s',
                    keyframes([
                    style({ transform: 'translateX(-45px)', offset: 0 }),
                    style({ transform: 'translateX(0px)', offset: 0.25 }),
                    style({ transform: 'translateX(-24px)', offset: 0.4 }),
                    style({ transform: 'translateX(0px)', offset: 0.55 }),
                    style({ transform: 'translateX(-12px)', offset: 0.65 }),
                    style({ transform: 'translateX(0px)', offset: 0.75 }),
                    style({ transform: 'translateX(-6px)', offset: 0.82 }),
                    style({ transform: 'translateX(0px)', offset: 0.87 }),
                    style({ transform: 'translateX(-4px)', offset: 0.93 }),
                    style({ transform: 'translateX(0px)', offset: 1 }),
                    ]),
                ),
            ]),
        ]),
        trigger('leavingRightAnimation', [
            transition('* => true', [
                animate(
                    '0.2s',
                    keyframes([
                    style({ transform: 'translateX(-5%)', offset: 0.1 }),
                    style({ transform: 'translateX(100%)', offset: 1 }),
                    ]),
                ),
            ]),
        ]),
        trigger('enteringRightAnimation', [
            transition('* => true', [
                animate(
                    '0.2s',
                    keyframes([
                    style({ transform: 'translateX(45px)', offset: 0 }),
                    style({ transform: 'translateX(0px)', offset: 0.25 }),
                    style({ transform: 'translateX(24px)', offset: 0.4 }),
                    style({ transform: 'translateX(0px)', offset: 0.55 }),
                    style({ transform: 'translateX(12px)', offset: 0.65 }),
                    style({ transform: 'translateX(0px)', offset: 0.75 }),
                    style({ transform: 'translateX(6px)', offset: 0.82 }),
                    style({ transform: 'translateX(0px)', offset: 0.87 }),
                    style({ transform: 'translateX(4px)', offset: 0.93 }),
                    style({ transform: 'translateX(0px)', offset: 1 }),
                    ]),
                ),
            ]),
        ]),
    ],
    standalone: false
})
export class ApSearchFiltersConfigVisibilityComponent {
    movingFilter: { filter: SearchParam; isPrimary: boolean } | null = null;
    primaryChangingFilter: SearchParam | null = null;
    selected: string = '';
    movingUp$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    movedUp$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    movingDown$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    movedDown$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    leavingLeft$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    enteringLeft$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    leavingRight$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    enteringRight$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    primaryFilters: SearchParam[] = [];
    secondaryFilters: SearchParam[] = [];

    @Input() set filters(searchParam: SearchParam[]) {
        const _filters = adjustFilters(searchParam);
        this.primaryFilters = _filters.filter((item) => item.layout?.row === 0);
        this.secondaryFilters = _filters.filter((item) => item.layout?.row === 1);
    }
    get filters(): SearchParam[] {
        return [...this.primaryFilters, ...this.secondaryFilters];
    }

    @Output() filtersChanged: EventEmitter<SearchParam[]> = new EventEmitter();

    labelTranslationKeyToString = labelTranslationKeyToString;

    trackBy: TrackByFunction<SearchParam> = (_index, filter) => {
        return filter.property.name;
    };

    justMovedDown$: BehaviorSubject<string> = new BehaviorSubject('');
    justMovedUp$: BehaviorSubject<string> = new BehaviorSubject('');

    select = (filter: SearchParam) => {
        this.selected = filter.property.name;
    };

    onMovingUpAnimationEnd = (event: AnimationEvent) => {
        if (String(event.toState) !== String(true) || this.movingFilter === null) return;
        const { filter, isPrimary } = this.movingFilter;
        this.moveToPrevPosition(filter, isPrimary);
        setTimeout(() => {
            this.movedUp$.next(filter.property.name);
        });
    };

    onMovedUpAnimationEnd = (event: AnimationEvent) => {
        if (String(event.toState) !== String(true) || this.movingFilter === null) return;
        this.movingFilter = null;
        setTimeout(() => {
            this.movingUp$.next(null);
            this.movedUp$.next(null);
        });
    };

    onMovingDownAnimationEnd = (event: AnimationEvent) => {
        if (String(event.toState) !== String(true) || this.movingFilter === null) return;
        const { filter, isPrimary } = this.movingFilter;
        this.moveToNextPosition(filter, isPrimary);
        setTimeout(() => {
            this.movedDown$.next(filter.property.name);
        });
    };

    onMovedDownAnimationEnd = (event: AnimationEvent) => {
        if (String(event.toState) !== String(true) || this.movingFilter === null) return;
        this.movingFilter = null;
        setTimeout(() => {
            this.movingDown$.next(null);
            this.movedDown$.next(null);
        });
    };

    onPrimaryFilterLeft = (event: AnimationEvent) => {
        const filter = this.primaryChangingFilter;
        if (String(event.toState) !== String(true) || filter === null) return;
        this.changeFilterRow(filter, false);
        setTimeout(() => {
            this.enteringRight$.next(filter.property.name);
        });
    };

    onSecondaryFilterLeft = (event: AnimationEvent) => {
        const filter = this.primaryChangingFilter;
        if (String(event.toState) !== String(true) || filter === null) return;
        this.changeFilterRow(filter, true);
        setTimeout(() => {
            this.enteringLeft$.next(filter.property.name);
        });
    };

    onFilterEntered = (event: AnimationEvent) => {
        const filter = this.primaryChangingFilter;
        if (String(event.toState) !== String(true) || filter === null) return;
        this.primaryChangingFilter = null;
        setTimeout(() => {
            this.leavingRight$.next(null);
            this.leavingLeft$.next(null);
            this.enteringLeft$.next(null);
            this.enteringRight$.next(null);
        });
    };

    primaryChangesAllow = (filter: SearchParam): boolean => {
        if (!!filter.layout && filter.layout.row === 0) return true;
        return this.primaryFilters.length < FILTER_PER_ROW;
    };

    moveNextAllow = (filter: SearchParam, isPrimary: boolean = false): boolean => {
        const length = isPrimary ? this.primaryFilters.length : this.secondaryFilters.length;
        return !!filter.layout && filter.layout.column < length - 1;
    };

    movePrevAllow = (filter: SearchParam): boolean => !!filter.layout && filter.layout.column > 0;

    primaryChanged = (event: MatSlideToggleChange, filter: SearchParam) => {
        this.select(filter);
        const isPrimary = event.checked;
        if (this.primaryChangingFilter || (isPrimary && this.primaryFilters.length >= FILTER_PER_ROW)) return;
        this.primaryChangingFilter = filter;
        if (isPrimary) this.changeFromSecondaryToPrimary();
        else this.changeFromPrimaryToSecondary();
    };

    changeFromPrimaryToSecondary = () => {
        if (!this.primaryChangingFilter) return;
        const filter = this.primaryChangingFilter;
        setTimeout(() => {
            this.leavingLeft$.next(filter.property.name);
        });
    };
    changeFromSecondaryToPrimary = () => {
        if (!this.primaryChangingFilter) return;
        const filter = this.primaryChangingFilter;
        setTimeout(() => {
            this.leavingRight$.next(filter.property.name);
        });
    };

    changeFilterRow = (filter: SearchParam, isPrimary: boolean) => {
        if (filter.layout) {
            filter.layout.row = isPrimary ? 0 : 1;
        }
        this.changeFilters();
    };

    moveUp = (filter: SearchParam, isPrimary: boolean) => {
        if (this.movingFilter) return;
        this.movingFilter = {
            filter,
            isPrimary,
        };
        this.movingUp$.next(filter.property.name);
    };

    moveDown = (filter: SearchParam, isPrimary: boolean) => {
        if (this.movingFilter) return;
        this.movingFilter = {
            filter,
            isPrimary,
        };
        this.movingDown$.next(filter.property.name);
    };

    moveToNextPosition = (filter: SearchParam, isPrimary: boolean = false) => {
        this.select(filter);
        const filters = isPrimary ? this.primaryFilters : this.secondaryFilters;
        const fromPos = filters.indexOf(filter);
        if (fromPos < 0 || fromPos >= filters.length - 1) return;
        const toPos = fromPos + 1;
        this.moveFilter(filters, fromPos, toPos);
        this.changeFilters();
    };

    moveToPrevPosition = (filter: SearchParam, isPrimary: boolean = false) => {
        this.select(filter);
        const filters = isPrimary ? this.primaryFilters : this.secondaryFilters;
        const fromPos = filters.indexOf(filter);
        if (fromPos <= 0) return;
        const toPos = fromPos - 1;
        this.moveFilter(filters, fromPos, toPos);
        this.changeFilters();
    };

    changeFilters = () => {
        this.filtersChanged.emit(this.filters);
    };

    private moveFilter = (filters: SearchParam[], fromPos: number, toPos: number): void => {
        filters.splice(toPos, 0, filters.splice(fromPos, 1)[0]);
        filters.forEach((filter, index) => {
            if (filter.layout) {
                filter.layout.column = index;
            }
        });
    };
}
